import React from 'react';
import { TFunction } from 'react-i18next';
import {
  Text,
  Link,
  CodeInline,
  Stack,
  Trans,
} from '@piwikpro/ui-components';
import { App } from '../../../model';

interface IOSInstallProps {
  app: App
  t: TFunction
}

const IOSInstall: React.FC<IOSInstallProps> = ({
  app,
  t,
}) => (
  <Stack vertical>
    <Stack.Item>
      <Stack vertical spacing="narrow">
        <Stack.Item>
          <Text as="p">
            <Trans
              i18nKey="apps.details.installation.ios.instruction.line1.part1"
              components={[
                <b>text</b>,
              ]}
            />
          </Text>
        </Stack.Item>
        <Stack.Item>
          <Stack>
            <Stack.Item />
            <Stack.Item>
              <Text as="p">
                <Trans
                  i18nKey="apps.details.installation.ios.instruction.line1.part2"
                  components={[
                    <CodeInline dataId="TextStyle">Code</CodeInline>,
                  ]}
                />
              </Text>
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Stack>
            <Stack.Item />
            <Stack.Item>
              <Text as="p" size={12} dataId="Caption" color="InkLighter">
                <Trans
                  i18nKey="apps.details.installation.ios.instruction.line1.part3-example"
                  components={[
                    <CodeInline dataId="TextStyle">Code</CodeInline>,
                    <Link size="small" href="https://cocoapods.org/pods/PiwikPROSDK">latest release</Link>,
                  ]}
                />
              </Text>
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Stack>
            <Stack.Item />
            <Stack.Item>
              <CodeInline dataId="TextStyle">
                pod &apos;PiwikPROSDK&apos;, &apos;~
                {'>'}
                {' '}
                2.1.1&apos;
              </CodeInline>
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Text as="p">
            <Trans
              i18nKey="apps.details.installation.ios.instruction.line2-part1"
              components={[
                <CodeInline dataId="TextStyle">Code</CodeInline>,
              ]}
            />
          </Text>
        </Stack.Item>
        <Stack.Item>
          <Text as="p">
            <Trans
              i18nKey="apps.details.installation.ios.instruction.line3-import"
              components={[
                <CodeInline dataId="TextStyle">Code</CodeInline>,
              ]}
            />
          </Text>
        </Stack.Item>
        <Stack.Item>
          <Text as="p">
            <Trans
              i18nKey="apps.details.installation.ios.instruction.line4-new"
              components={[
                <Link href="https://developers.piwik.pro/en/latest/data_collection/mobile/Piwik_PRO_SDK_for_iOS.html">Set up the SDK</Link>,
              ]}
            />
          </Text>
        </Stack.Item>
        <Stack.Item>
          <Text as="p">
            <Trans
              i18nKey="apps.details.installation.ios.instruction.line4"
              components={[
                <Link href={`/analytics/#/${app.id}/settings/debugger/`}>tracker debugger</Link>,
              ]}
            />
          </Text>
        </Stack.Item>
      </Stack>
    </Stack.Item>
    <Stack.Item>
      <Text as="p">
        {t('apps.details.installation.instruction.help.part1')}
        <Link href="https://developers.piwik.pro/en/latest/integrations/Piwik_PRO_SDK_for_iOS.html">
          {t('apps.details.installation.links.installGuide')}
        </Link>
        {t('apps.details.installation.instruction.help.part2')}
        <Link href="http://community.piwik.pro/">
          {t('apps.details.installation.links.community')}
        </Link>
        .
      </Text>
    </Stack.Item>
  </Stack>
);

export default IOSInstall;
